<form [formGroup]="form" novalidate>
  <label>Vagas Destinadas ao Gestor</label>

  <div formArrayName="modalidadeVaga" class="mt-4">
    @if (modalidadeVaga.controls.length === 0 && cicloSelected && isVagasLoaded) {
      <div class="alert alert-warning" role="alert">
        Nenhuma vaga disponível para confirmação, de acordo com o quadro de vagas publicadas no portal oficial do programa.
      </div>
    }
    @if (!cicloSelected) {
      <div class="alert alert-info">
        Selecione um ciclo do edital para confirmar a quantidade de vagas destinadas ao gestor.
      </div>
    }
    @if (confirmacaoVaga?.rascunho === false && isPeriodoVigenteForEnable()) {
      <div class="alert alert-info" role="alert">
        <i class="fas fa-info-circle me-1"></i>
        Confirmação efetivada em
        <strong>{{ confirmacaoVaga.dataConfirmacao | date: "dd/MM/yyyy HH:mm" }}</strong>.
        Você pode alterar as quantidades e os INEs até o fim do período; as alterações só passam a
        valer após concluir novamente a etapa <strong>Resumo e Confirmação</strong>.
      </div>
    }


    @for (mv of modalidadeVagas; track mv.idModalidade) {
      <app-card-collapse
        [titulo]="'Informações da Vaga'"
        [isCollapsed]="false"
        [enableCollapse]="false"
      >
        <div>
          <h6>{{ mv.modalidade }}</h6>
          @for (item of mv.data; track item.index) {
            <div [formGroupName]="item.index" class="mt-4">
              <span class="badge rounded-pill text-bg-primary">{{
                item.tipoEquipe
              }}</span>
              <div class="row">
                <div class="col-6">
                  <label for="">Quantidade ofertada</label>
                  <br-input
                    type="number"
                    [value]="item.totalVagas"
                    [disabled]="true"
                    ariaLabel="Quantidade ofertada"
                  ></br-input>
                  <small class="text-muted"
                    >Vagas destinadas nesta modalidade</small
                  >
                </div>

                <div class="col-6">
                  <label for="vaga_{{ item.index }}"
                    >Quantidade a confirmar</label
                  >
                  <div class="br-input medium">
                    <input
                      type="number"
                      id="vaga_{{ item.index }}"
                      formControlName="vagasConfirmadas"
                    />
                    @if (
                      modalidadeVaga.at(item.index).get("vagasConfirmadas")
                        ?.invalid &&
                      modalidadeVaga.at(item.index).get("vagasConfirmadas")
                        ?.dirty &&
                      modalidadeVaga.at(item.index).get("vagasConfirmadas")
                        ?.touched
                    ) {
                      @if (
                        modalidadeVaga.controls[item.index]
                          .get("vagasConfirmadas")
                          ?.hasError("max")
                      ) {
                        <br-message
                          state="danger"
                          [isFeedback]="true"
                          message="A quantidade de vagas confirmadas não pode ser maior que a ofertada."
                        ></br-message>
                      } @else {
                        <br-message
                          state="danger"
                          [isFeedback]="true"
                          message="A quantidade de vagas a confirmar é obrigatória."
                        ></br-message>
                      }
                    }
                  </div>
                  <small>Máximo {{ item.totalVagas }} vagas</small>
                </div>
              </div>
            </div>
          }
        </div>
      </app-card-collapse>
    }
  </div>

  <hr />

  <div class="d-flex justify-content-between mt-3">
    <br-button
      type="button"
      [emphasis]="'secondary'"
      [ariaLabel]="'Voltar'"
      title="Voltar"
      [isLoading]="isSubmitting"
      (click)="cancel()"
      >Voltar</br-button
    >
    @if (hasCadastroReserva && this.modalidadeVagas.length === 0 && isVagasLoaded) {
      <br-button
        type="button"
        [emphasis]="'secondary'"
        title="Imprimir Comprovante"
        [ariaLabel]="'Imprimir Comprovante'"
        (click)="onPrintCadastroReserva.emit()"
      >
        <i class="fa fa-print"></i> Imprimir Comprovante
      </br-button>
    }
    @if (hasCadastroReserva && isVagasLoaded && isPeriodoVigenteForEnable()) {
      <br-button
        type="button"
        [emphasis]="'secondary'"
        title="Alterar Cadastro Reserva"
        [ariaLabel]="'Alterar Cadastro Reserva'"
        (click)="onAlterarCadastroReserva.emit()"
      >
        <i class="fa fa-pen"></i> Alterar Cadastro Reserva
      </br-button>
    }
    @if (this.modalidadeVagas.length > 0) {
      <br-button
        type="button"
        [emphasis]="'primary'"
        title="Próximo"
        [ariaLabel]="'Próximo'"
        (click)="next()"
        [isLoading]="isSubmitting"
        [disabled]="!isFormValid()"
      >
        Próximo
      </br-button>
    }
  </div>
</form>
